import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=d0718afc&scoped=true"
import script from "./CommentList.vue?vue&type=script&lang=js"
export * from "./CommentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0718afc",
  null
  
)

export default component.exports